import { render, staticRenderFns } from "./TimetableAddRecord.vue?vue&type=template&id=2c15e020&scoped=true&"
import script from "./TimetableAddRecord.vue?vue&type=script&lang=js&"
export * from "./TimetableAddRecord.vue?vue&type=script&lang=js&"
import style0 from "./TimetableAddRecord.vue?vue&type=style&index=0&id=2c15e020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15e020",
  null
  
)

export default component.exports